import { Spin } from 'antd';
import React from 'react'
import AppLoader from './AppLoader';
import CustomSteps from './CustomSteps'
import WizardForm from './WizardForm'

export default class WizardFormV2 extends WizardForm {
    static defaultProps = {
        ...WizardForm.defaultProps,
        formLayout: "vertical"
    }
    render() {
        const { currentStep, visited } = this.state;
        const { pages, title, loading, isEdit } = this.props;
        const steps = pages.map(page => page.name);
        const form = this.renderForm();
        return (
            <Spin spinning={!!loading} indicator={<AppLoader style={{ color: "#ccc" }} />}>
                <div style={{position: "absolute", color: "white", fontSize: 14, width: 210}} className="text-bold">{title}</div>
                <CustomSteps steps={steps} currentStep={currentStep} onStepClick={this.goToStep} visited={visited} isEdit={isEdit}>
                    {loading ? 
                        <div style={{ height: '100px' }} /> // Adding blank space just so that modal doesn't look collapsed 
                    : form}
                </CustomSteps>
            </Spin>
        )
    }
}

